import * as dotenv from 'dotenv';

// Only load dotenv in a Node.js environment
if (typeof process !== 'undefined' && process.env) {
  dotenv.config({ path: '.env' });
}

export function getNodeEnvVariable(key: string): string | undefined {
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key];
  }
  return undefined;
}
